export const currency = {
  // Currency dropdown
  currencySearch: "Search currency...",
  currencyFiatOnly: "Fiat Only",
  currencyManage: "Manage",
  currencySelectCurrency: "Select currency",
  currencyNoResults: "No currencies found",
  currencyTypeFiat: "Fiat",
  currencyTypeCrypto: "Crypto",

  // Currency management modal
  currencyManageTitle: "Manage Currencies",
  currencyManageFiatTab: "Fiat Currencies",
  currencyManageCryptoTab: "Cryptocurrencies",
  currencyManageSearchPlaceholder: "Search in {type}...",
  currencyManageNoFiat: "No fiat currencies found",
  currencyManageNoCrypto: "No cryptocurrencies found",
  currencyManageClose: "Close",

  currencyName: "Currencies",
  cryptoNames: "Cryptos",

  // Currency names
  currencyZAR: "South African Rand",
  currencyUSD: "US Dollars",
  currencyUSDT: "Tether USD",
  currencyCLP: "Chilean Pesos",
  currencyVES: "Venezuelan Bolívars",

  // Currency symbols
  currencySymbolZAR: "R",
  currencySymbolUSD: "US$",
  currencySymbolUSDT: "₮",
  currencySymbolCLP: "CL$",
  currencySymbolVES: "Bs.",

  // Conversion
  currencyConversionError: "Error converting currency",
  currencyLoadingRates: "Loading exchange rates...",
  currencyManagementNote: "Enable or disable currencies to show in the dropdown",
};
